import React from 'react';
import { Language } from '../App';
type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  text?: string;
  language: Language;
  centered?: boolean;
  light?: boolean;
};
export function SectionHeading({
  eyebrow,
  title,
  text,
  centered = false,
  light = false
}: SectionHeadingProps) {
  return <div className={centered ? 'mx-auto max-w-3xl text-center' : 'max-w-3xl'} data-id="element-50">
      <p className={`mb-3 text-xs font-bold uppercase tracking-[0.24em] ${light ? 'text-[#d6b45f]' : 'text-[#a47b2a]'}`} data-id="element-51">
        {eyebrow}
      </p>
      <h2 className={`font-serif text-3xl leading-tight sm:text-4xl ${light ? 'text-white' : 'text-[#08233f]'}`} data-id="element-52">
        {title}
      </h2>
      {text && <p className={`mt-5 text-base leading-7 ${light ? 'text-slate-300' : 'text-slate-600'}`} data-id="element-53">
          {text}
        </p>}
    </div>;
}